import washington from '../images/gallery/washington.png';
import shoe from '../images/gallery/shoe.png';
import falls from '../images/gallery/falls.png';
import sunset from '../images/gallery/sunset.png';
import renfest from '../images/gallery/renfest.png';
import swamp from '../images/gallery/swamp.png';
import concert from '../images/gallery/concert.png';
import eagle from '../images/gallery/eagle.png';
import irwin from '../images/gallery/irwin.png';
import seabird from '../images/gallery/seabird.png';
import arlington from '../images/gallery/arlington.png';
import flowers from '../images/gallery/flowers.png';
import ring from '../images/gallery/ring.png';
import farm from '../images/gallery/farm.png';
import eno from '../images/gallery/eno.png';
import eclipse from '../images/gallery/eclipse.png';

export const galleryData = [
  {
    img: washington,
    title: 'Washington Monument',
    description: 'Our first weekend together',
    url: 'https://en.wikipedia.org/wiki/Washington_Monument',
  },
  {
    img: shoe,
    title: 'Shoe at Courthouse Hyatt',
    description: `This is near Elliot's house`,
    url: 'https://schuppcompanies.com/hyatt-place-courthouse-arlington-achieves-public-art-in-courthouse-2/',
  },
  {
    img: sunset,
    title: 'Skyline Drive',
    description: 'Tequila sunrises at sunset',
    url: 'https://en.wikipedia.org/wiki/Washington_Monument',
  },
  {
    img: swamp,
    title: 'Cypress Gardens',
    description: 'The place from The Notebook',
    url: 'https://www.southernliving.com/travel/south-carolina/notebook-movie-tour-charleston-sc',
  },
  {
    img: irwin,
    title: 'Before Brooklyn Bagels',
    description: 'A true staple of Courthouse in Arlington',
    url: 'https://www.brooklynbagelva.com/',
  },
  {
    img: falls,
    title: 'Great Falls',
    description: 'Hiking near the water',
    url: 'https://www.nps.gov/grfa/index.htm',
  },
  {
    img: renfest,
    title: 'Rennaissance Festival',
    description: 'Lot of weirdos here',
    url: 'https://en.wikipedia.org/wiki/Rennaissance',
  },
  {
    img: seabird,
    title: 'Acadia National Park',
    description: 'Making sure the birds are well fed',
    url: 'https://www.nps.gov/acad/index.htm',
  },
  {
    img: arlington,
    title: 'Kennedy Center',
    description: 'Saw a play that went really badly',
    url: 'https://www.kennedy-center.org/',
  },
  {
    img: concert,
    title: 'Chris Renzema Concert',
    description: 'It was some music',
    url: 'https://www.chrisrenzema.com/',
  },
  {
    img: eagle,
    title: 'Dollywood',
    description: 'Best dang amusement park this side of the Mississippi',
    url: 'https://www.dollywood.com/',
  },
  {
    img: flowers,
    title: 'Great Smokey Mountains',
    description: 'Adventured through a flower field',
    url: 'https://www.nps.gov/grsm/index.htm',
  },
  {
    img: ring,
    title: 'Shenandoah National Park',
    description: 'Got engaged in a big meadow',
    url: 'https://www.nps.gov/shen/index.htm',
  },
  {
    img: farm,
    title: 'Amissville',
    description: 'Uncle Eric and Aunt Corinna live here',
    url: 'https://en.wikipedia.org/wiki/Amissville,_Virginia',
  },
  {
    img: eno,
    title: 'Burke Lake Park',
    description: 'Enoing at goblin hour',
    url: 'https://www.fairfaxcounty.gov/parks/burkelake',
  },
  {
    img: eclipse,
    title: 'Cleveland, OH',
    description: 'We were in the path of totality',
    url: 'https://www.thisiscleveland.com/2024-solar-eclipse',
  },
];
